import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../styles/NotFound.css";
import Footer from "./Footer";

export default function NotFound() {
  const { t } = useTranslation("notFound");

  return (
    <>
      <div className="notfound">
        <div className="notfound__inner">
          <span className="notfound__code">404</span>
          <h1 className="notfound__title">{t("title")}</h1>
          <p className="notfound__desc">{t("desc")}</p>
          <Link to="/" className="notfound__btn">{t("btn")}</Link>
        </div>
      </div>
      <Footer />
    </>
  );
}
